(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;

    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const toggleCollapsible = (event, toggles) => {
    if (!toggles) return;

    const answer = event.currentTarget.querySelector(
      ".collapsible-content__answer"
    );
    const activeItem = Array.from(toggles).find((item) =>
      item.classList.contains("active")
    );

    if (event.currentTarget !== activeItem) {
      if (activeItem) {
        activeItem.classList.remove("active");
        const activeAnswer = activeItem.querySelector(
          ".collapsible-content__answer"
        );
        if (activeAnswer) slideUp(activeAnswer);
      }
      event.currentTarget.classList.add("active");
      slideDown(answer);
    } else {
      event.currentTarget.classList.remove("active");
      slideUp(answer);
    }
  };

  // Load more/less functionality
  const handleLoadMoreToggle = (button, hiddenItems) => {
    const isExpanded = button.classList.contains('expanded');
    const buttonText = button.querySelector('.collapsible-content__button-text');
    const loadMoreLabel = button.dataset.loadMoreLabel;
    const loadLessLabel = button.dataset.loadLessLabel;

    if (isExpanded) {
      // Hide extra items
      hiddenItems.forEach(item => {
        item.classList.add('collapsible-content__item--hidden');
      });
      button.classList.remove('expanded');
      buttonText.textContent = loadMoreLabel;
    } else {
      // Show all items
      hiddenItems.forEach(item => {
        item.classList.remove('collapsible-content__item--hidden');
      });
      button.classList.add('expanded');
      buttonText.textContent = loadLessLabel;
    }
  };

  const initLoadMoreButton = (section) => {
    const toggleButton = section.querySelector('.collapsible-content__button--toggle');
    if (!toggleButton) return;

    const itemsContainer = section.querySelector('.collapsible-content__items');
    const initialCount = parseInt(itemsContainer.dataset.initialCount) || 6;
    const allItems = section.querySelectorAll('.collapsible-content__item');
    const hiddenItems = Array.from(allItems).slice(initialCount);

    // Only show the button if there are hidden items
    if (hiddenItems.length === 0) {
      toggleButton.style.display = 'none';
      return;
    }

    toggleButton.addEventListener('click', () => {
      handleLoadMoreToggle(toggleButton, hiddenItems);
    });
  };

  const initCollapsibleContent = (section) => {
    if (!section || !section?.classList.contains("collapsible-content-section"))
      return;
    
    const toggles = section.querySelectorAll(".collapsible-content__item");

    // Initialize collapsible functionality
    toggles.forEach((toggle) =>
      toggle.addEventListener("click", (event) =>
        toggleCollapsible(event, toggles)
      )
    );

    // Initialize load more/less functionality
    initLoadMoreButton(section);
  };

  document.addEventListener(
    "DOMContentLoaded",
    () => initCollapsibleContent(document.querySelector('.collapsible-content-section'))
  );

  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleContent(event.target);
  });
})();
